import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import { setAuthState } from 'src/store/user/userSlice';
import UsersApi from 'api/users';
import Loader from 'src/components/Loader/Loader';

const Callback = () => {
  const { isAuthenticated, getAccessTokenSilently, loginWithRedirect, isLoading } = useAuth0();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      getAccessTokenSilently()
        .then(async () => {
          const { data } = await UsersApi.fetchCurrentUser();
          const { data: flags } = await UsersApi.fetchFeatureFlags();

          dispatch(
            setAuthState({
              isAuthenticated: true,
              isLoading: false,
              user: data.user,
              featureFlags: flags,
              campaignLimits: data.campaignLimits,
              intercomJwt: data.intercomJwt
            })
          );
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
            console.error('Response headers:', error.response.headers);
          } else if (error.request) {
            console.error('Request data:', error.request);
          } else {
            console.error('Error message:', error.message);
          }
        });
    } else {
      loginWithRedirect({
        appState: { returnTo: '/' },
        authorizationParams: { prompt: 'login' }
      });
    }
  }, [isAuthenticated, getAccessTokenSilently, dispatch, loginWithRedirect, isLoading]);

  return <Loader />;
};

export default Callback;
